import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const NewGig = (props) => { 
    const item = props.item;
    const startDate = new Date(item.StartDate);
    const startDateText = startDate.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });
    return (       
        <li>
            <div className="feed-icon">
                <svg className="icon icn-gig">
                    <use xlinkHref="#icn-calendar" />
                </svg>
            </div>
            <Link to={`/${item.Username}`} className="thumbnail">
                <div className="userthumb">
                    <img src={props.getThumbnail(item.Thumbnail, item.RoleType)} alt="profile picture" />
                </div>
            </Link>
            <p className="type">NEW GIG <span className="time">{item.DateText}</span></p>
            <div className="message">
                <p>
                    <Link to={`/${item.Username}`}><strong>{item.DisplayName}</strong></Link> has announced a new <Link to={`Gigs/${item.ID}`} className="transition"><strong>gig</strong></Link> on {startDateText} in {item.Location}
                </p>
            </div>
        </li>

    );
};

NewGig.propTypes = {
    item: PropTypes.object.isRequired,
    getThumbnail: PropTypes.func.isRequired
};

export default NewGig;